/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum PriceType {
  INCLUDED_IN_BASE_FEE = "INCLUDED_IN_BASE_FEE",
  TIME_AND_MATERIAL = "TIME_AND_MATERIAL",
  CAPACITY_BASED_FEE = "CAPACITY_BASED_FEE",
  CUSTOM = "CUSTOM",
}

export enum PriceTypeDisplay {
  INCLUDED_IN_BASE_FEE = "Included in Base Fee",
  TIME_AND_MATERIAL = "Time and Material",
  CAPACITY_BASED_FEE = "Capacity Based Fee",
  CUSTOM = "Custom",
}
